export default {
  postureReport: "Rapport de posture",
  postureData: "Données de posture",
  postureDataContrast: "Contraste des données de posture",
  postureRiskContrast: "Contraste du risque de posture",
  postureDataTrend: "Tendance des données de posture",
  postureRiskTrend: "Tendance du risque de posture",
  postureLogData: "Données de Journal de Posture",
  lateralhead: "Inclinaison latérale de la tête",
  unevenshoulder: "Épaules inégales",
  scoliosis: "Scoliose",
  unevenhip: "Inclinaison latérale du bassin",
  xleg: "Jambe en X",
  oleg: "Jambe en O",
  roundedshoulder: "Épaule arrondie",
  kneehyperextension: "Hyperextension du genou",
  trunkforwardtilt: "Trunk forward tilt",
  trunklateraltilt: "Trunk Lateral Tilt",
  forwardhead: "Tête vers l'avant",
  toTheLeft: "(gauche)",
  toTheRight: "(droite)",
  bracketsLeft: "(L)",
  bracketsRight: "(R)",
  bracketsNormal: "(Normal)",
  leg: "Jambes",
  legLeft: "Jambes (L)",
  legRight: "Jambes (R)",
  riskAssessment: "Évaluation du risque",
  muscleState: "État musculaire",
  muscleStateDesc: "Aucune condition musculaire anormale n'a été trouvée",
  testTime: "Temps de test",
  hRisk: "H",
  mRisk: "M",
  lRisk: "L",
  item: "Article",
  degree: "°",
  percent: "%",
  mm: "mm",
  moireImage: "Image moiré",
  lAbnormalRisk: "L Risque",
  mAbnormalRisk: "M Risque",
  hAbnormalRisk: "H Risque",
  highRisk: "Haut risque",
  riskAnalysis: "Analyse du risque",
  conclusionRecommendation: "Conclusion et recommandation",
  solution: "Lösung",
  movePosition: "Cliquez sur le point pour déplacer la position",
  confirmTheClose: "Pas encore sauvegardé, confirmez-vous la fermeture?",
  closeInfo: "Pas encore sauvegardé, confirmez-vous la fermeture?",
  share: "Partager",
  front: "Devant",
  side: "Côté",
  back: "Derrière",
  otherSide: "Autre Côté",
  points: "Puntos",
  angle: "Angle",
  name: "Nom",
  gender: "Genre",
  male: "Masculin",
  female: "Féminin",
  age: "Âge",
  year: "ans",
  height: "Hauteur",
  weight: "Poids",
  time: "Temps",
  patientId: "ID Patient",
  save: "Sauvegarder",
  saveModify: "Sauvegarder Modifier",
  print: "Imprimer",
  cancel: "Annuler",
  zoomIn: "Zoomer In",
  zoomOut: "Zoomer Out",
  ok: "OK",
  return: "Retour",
  empty: "",
  unknown: "inconnu",
  succeedToCopy: "Copié avec succès",
  succeedToSave: "Sauvegardé avec succès",
  headForwardDistance: "Distance de tête vers l'avant",
  pelvisForwardTilt: "Inclinaison pelvienne vers l'avant",
  wristHipDistanceLeft: "Distance poignet à hanche (Gauche)",
  wristHipDistanceRight: "Distance poignet à hanche (droite)",
  evaluator: "Évaluateur",
  reportDate: "Date du rapport",
  introduction: "Introduction",
  doctorIntroDefault: "Domaine professionnel : Médecine de rééducation, évaluation et correction de la posture | Années d'expérience : plus de 5 ans | Expertise : Rééducation des blessures sportives, correction posturale, gestion de la douleur",
  recoveryLog: "Journal de récupération",
  returnToReport: "Retour au rapport",
  loading: "Chargement...",
  showToolbox: "Afficher la boîte à outils",
  hideToolbox: "Masquer la boîte à outils",
};

